module.exports = __webpack_public_path__ + "static/pic02-c917e815ac575fb9428a796ad2150bc9.jpg";